import { ValidationError } from "joi";

export interface IOemMetaData {
	_id?: string;
	financialStatementVersion: string;
	oemName: string;
	oemReference: string;
	version: string;
	franchisesNames: string[];
	franchises: {
		_id?: string;
		franchise: string;
		areas: string;
	}[];
}

export interface ICommonArea {
	_id?: string;
	areaLabel: string;
	areaValue: string;
	areaKey: string;
	areaShort: string;
	version: string;
}

export interface IPayloadArea extends ICommonArea {
	areas: IPayloadArea[]; // Nested
}

export interface IArea extends ICommonArea {
	area?: IArea; // Nested area
}

export interface IMetaArea {
	areaLabel: string;
	areaValue: string;
	areaKey: string;
	areaShort: string;
	version: string;
	areas?: IMetaArea[];
}

export interface IGroup {
	_id?: string;
	franchiseName: string;
}

export interface IFranchise {
	_id?: string;
	dealerCode: string;
	franchise: string;
	area?: IArea;
	groups: IGroup[];
	isCombined: boolean;
}

export interface ILocationDealerCode {
	_id?: string;
	oemName: string;
	oemReference: string;
	version: string;
	financialStatementVersion: string;
	dealerCodeFS: string;
	legalName: string;
	dba: string;
	franchises: IFranchise[];
}

export type TLocationDealerCodeState = ILocationDealerCode[];

export enum EActionType {
	UPDATE_STATE = "UPDATE_STATE",
	UPDATE_OEM = "UPDATE_OEM",
	ADD_OEM = "ADD_OEM",
	DELETE_OEM = "DELETE_OEM",
	UPDATE_FRANCHISE = "UPDATE_FRANCHISE",
	ADD_FRANCHISE = "ADD_FRANCHISE",
	DELETE_FRANCHISE = "DELETE_FRANCHISE",
	UPDATE_AREA = "UPDATE_AREA",
}

export interface IAction {
	oemIndex?: number;
	franchiseIndex?: number;
}

export interface IUpdateOemAction extends IAction {
	oemName?: string;
	oemReference?: string;
	version?: string;
	financialStatementVersion?: string;
	dba?: string;
	dealerCodeFS?: string;
	legalName?: string;
}

export interface IUpdateAreaAction extends IAction {
	area: IPayloadArea;
}

export interface IUpdateFranchiseAction extends IAction {
	franchise?: string;
	dealerCode?: string;
	area?: ICommonArea;
	isCombined?: boolean;
	groups?: IGroup[];
}

export type TAction =
	| { type: EActionType.UPDATE_STATE; payload: IAction; newState: TLocationDealerCodeState }
	| { type: EActionType.UPDATE_OEM; payload: IUpdateOemAction }
	| { type: EActionType.ADD_OEM; payload: IAction }
	| { type: EActionType.DELETE_OEM; payload: IAction }
	| { type: EActionType.UPDATE_FRANCHISE; payload: IUpdateFranchiseAction; isWarning?: boolean }
	| { type: EActionType.ADD_FRANCHISE; payload: IAction }
	| { type: EActionType.DELETE_FRANCHISE; payload: IAction }
	| { type: EActionType.UPDATE_AREA; payload: IUpdateAreaAction };

export type TErrors = ValidationError | null;

export type TPath = (string | number)[];

export type TFranchiseSelected = { franchiseName: string };

export type TGetFranchiseUpdatedProps = {
	franchise: IFranchise;
	selected: TFranchiseSelected[];
	oemMetaData?: IOemMetaData;
};
